import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';

import PeoplePicker from '../../components/PeoplePicker/PeoplePicker';
import mergeStates from '../../helpers/mergeStates';
import classes from './FormTaskEmbed.scss';
import SimplDatepicker from '../SimplDatepicker/SimplDatepicker';
import SplitButton from '../SplitButton/SplitButton';

import OvalIcon from '../../assets/ic_oval.svg';
import ContactCard from '../ContactCard/ContactCard';
import FormFileUpload from '../FormFileUpload/FormFileUpload';

class FormTaskEmbed extends React.Component {
  handleChange = (e, oldState, name, value) => {
    const nextState = mergeStates(e, this.props.task, name, value);
    this.props.onChange(nextState);
  };

  pickedAssignee = e => {
    const nextState = mergeStates(e, this.props.task);
    this.props.onChange(nextState);
  };

  renderDetail = () => {
    let title = 'Neue Aufgabe';
    if (
      typeof this.props.task !== 'undefined' &&
      typeof this.props.task.title !== 'undefined'
    ) {
      if (this.props.task.title.length) {
        title = this.props.task.title;
      }
    }

    let date = null;
    if (this.props.task.due_date) {
      date = (
        <span className={classes.meta}>
          bis{' '}
          {moment(this.props.task.due_date, 'YYYY-MM-DD HH:mm:ss').format(
            'DD.MM.YYYY',
          )}
        </span>
      );
    }

    let avatar = null;
    if (
      typeof this.props.task.assignee !== 'undefined' &&
      this.props.task.assignee !== null &&
      typeof this.props.task.assignee.id !== 'undefined'
    ) {
      avatar = (
        <ContactCard
          displayType="imageOnly"
          className="text-right"
          id={
            typeof this.props.task.assignee !== 'undefined'
              ? this.props.task.assignee.id
              : ''
          }
          name={
            typeof this.props.task.assignee !== 'undefined'
              ? this.props.task.assignee.name
              : ''
          }
          type="staff"
        />
      );
    }

    return (
      <article
        className={`${classes.detail} ${
          this.props.noBorder ? classes.noBorder : null
        }`}
      >
        <div className="row">
          <div className="col-xs-1 flex-vcenter">
            <Checkbox
              label=""
              checked={Boolean(this.props.task.is_done)}
              onClick={() =>
                this.handleChange(
                  null,
                  null,
                  'is_done',
                  !this.props.task.is_done,
                )
              }
            />
          </div>
          <div
            className="col-xs-9 pointer"
            onClick={() => this.handleChange(null, null, 'editing', true)}
          >
            <span className={classes.title}>{title}</span>
            {date}
          </div>
          <div className="col-xs-2 text-right">{avatar}</div>
        </div>
      </article>
    );
  };

  renderSaveButton = () => {
    if (this.props.dashboard) {
      return (
        <div className={`row ${classes.buttonRow}`}>
          <div className="col-xs-6" />
          <div className="col-xs-6">
            <RaisedButton
              label="Aufgabe erstellen"
              primary
              disabled={this.props.task.title.trim().length === 0}
              onMouseDown={() => this.props.saveTask()}
            />
          </div>
        </div>
      );
    }

    return (
      <div className="row">
        <div className="col-xs-12 col-sm-4" />
        <div className="col-xs-12 col-sm-4">
          <a
            href="#save"
            className="button button-primary text-center"
            onClick={e => {
              e.preventDefault();
              this.handleChange(null, null, 'editing', false);
            }}
          >
            Speichern
          </a>
        </div>
      </div>
    );
  };

  renderForm = () => {
    const notes = this.props.task.notes !== null ? this.props.task.notes : '';

    let title = 'Neue Aufgabe';
    if (
      typeof this.props.task !== 'undefined' &&
      typeof this.props.task.title !== 'undefined'
    ) {
      if (this.props.task.title.length) {
        title = this.props.task.title;
      }
    }

    let assignee = this.props.task.assignee;

    if (typeof assignee === 'object' && assignee !== null) {
      assignee = assignee.id;
    }

    const cssClass = this.props.dashboard ? null : classes.form;

    const titleHtml = this.props.dashboard ? null : (
      <div className="col-xs-12">
        <h3>{title}</h3>
      </div>
    );

    return (
      <article className={cssClass}>
        <div className={`row ${classes.firstRow}`}>
          {titleHtml}
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="title">
              Aufgabe
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <input
              name="title"
              required
              onChange={e => this.handleChange(e)}
              value={this.props.task.title}
              className={this.props.error ? 'error' : null}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="notes">
              Notiz
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <textarea
              name="notes"
              rows="4"
              onChange={e => this.handleChange(e)}
              value={notes}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="priority">
              Hohe Priorität
            </label>
          </div>
          <div className="col-xs-12 col-sm-4">
            <SplitButton
              fullWidth
              selected={this.props.task.priority}
              onSelect={priority =>
                this.handleChange(null, null, 'priority', priority)
              }
              buttons={[
                {
                  title: 'Normal',
                  value: 0,
                },
                {
                  title: 'Wichtig',
                  value: 1,
                  img: OvalIcon,
                },
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="assignee">
              Zuständiger
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <PeoplePicker
              name="assignee"
              type="users"
              clearable={false}
              value={assignee}
              default={this.props.defaultAssignee}
              onChange={e => this.pickedAssignee(e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="due_date">
              Zu erledigen bis
            </label>
          </div>
          <div className="col-xs-12 col-sm-4">
            <SimplDatepicker
              defaultValue={this.props.task.due_date}
              dateFormatSubmit="YYYY-MM-DD HH:mm:ss"
              onChange={date => {
                this.handleChange(null, null, 'due_date', date);
              }}
            />
          </div>
        </div>

        <FormFileUpload
          files={this.props.task.files}
          onUpdate={files => this.handleChange(null, null, 'files', files)}
          uploadText={'Hier klicken um Dateien anzuhängen'}
        />

        {this.renderSaveButton()}
      </article>
    );
  };

  render() {
    return this.props.task.editing ? this.renderForm() : this.renderDetail();
  }
}
FormTaskEmbed.propTypes = {
  onChange: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
  defaultAssignee: PropTypes.string,
  dashboard: PropTypes.bool,
  error: PropTypes.bool,
  saveTask: PropTypes.func,
  noBorder: PropTypes.bool,
};
FormTaskEmbed.defaultProps = {
  noBorder: false,
};
export default FormTaskEmbed;



// WEBPACK FOOTER //
// ./src/components/FormTaskEmbed/FormTaskEmbed.js